const UploadHistoryAmountType = {
  Single: "Single",
  Multiple: "Multiple",
};

module.exports = Object.freeze(UploadHistoryAmountType);
